(function(){
  'use strict';
  if (window.CRWNZPerformanceHelper) return;
  window.CRWNZPerformanceHelper = true;

  var doc = document.documentElement;
  var modeKey = 'crwnz_visual_mode';
  var noticeKey = 'crwnz_perf_notice_seen';
  var isTouch = (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) || (window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  var isMobileWidth = window.matchMedia && window.matchMedia('(max-width: 899px)').matches;
  var isCheckoutLike = /\/checkout|\/checkouts/i.test(location.pathname);

  function $(sel, root){ return (root || document).querySelector(sel); }
  function show(el){ if (el) el.hidden = false; }
  function hide(el){ if (el) el.hidden = true; }
  function isDesktopHelper(){ return !isTouch && !isMobileWidth && !isCheckoutLike; }

  function setMode(mode, reason){
    var aesthetic = mode === 'aesthetic' && isDesktopHelper();
    if (aesthetic) {
      doc.classList.add('crwnz-aesthetic-mode');
      doc.classList.remove('crwnz-performance-mode');
      try { localStorage.setItem(modeKey, 'aesthetic'); } catch(e) {}
    } else {
      doc.classList.add('crwnz-performance-mode');
      doc.classList.remove('crwnz-aesthetic-mode');
      try { localStorage.setItem(modeKey, 'performance'); } catch(e) {}
    }
    window.dispatchEvent(new CustomEvent('crwnz:visual-mode', { detail: { mode: aesthetic ? 'aesthetic' : 'performance', reason: reason || 'manual' }}));
    updateStatus(reason || 'manual');
  }

  function currentMode(){ return doc.classList.contains('crwnz-aesthetic-mode') ? 'aesthetic' : 'performance'; }

  function updateStatus(reason){
    var helper = $('[data-crwnz-perf]');
    var status = $('[data-crwnz-perf-status]');
    var label = $('[data-crwnz-mode-label]');
    var aestheticBtn = $('[data-crwnz-perf-aesthetic]');
    var performanceBtn = $('[data-crwnz-perf-performance]');
    var title = $('#crwnz-perf-title');
    var mode = currentMode();

    if (label) label.textContent = mode === 'aesthetic' ? 'Aesthetic mode' : 'Performance mode';
    if (helper) helper.classList.toggle('is-aesthetic', mode === 'aesthetic');

    if (title) title.textContent = mode === 'aesthetic' ? 'Aesthetic mode' : 'Effects disabled';
    if (status) {
      if (mode === 'aesthetic') {
        status.textContent = 'Aesthetic mode is active. If the site feels laggy, switch back to Performance mode or enable browser hardware acceleration.';
      } else if (reason === 'severe') {
        status.textContent = 'The site detected sustained slow frames and switched back to Performance mode. Essential animations still work in a lighter form.';
      } else {
        status.textContent = 'Performance mode is active. Essential animations still work in a lighter form.';
      }
    }
    if (aestheticBtn) {
      aestheticBtn.textContent = mode === 'aesthetic' ? 'Aesthetic mode on' : 'Enable aesthetic mode';
      aestheticBtn.classList.toggle('is-active', mode === 'aesthetic');
      aestheticBtn.setAttribute('aria-pressed', mode === 'aesthetic' ? 'true' : 'false');
    }
    if (performanceBtn) {
      performanceBtn.textContent = mode === 'aesthetic' ? 'Back to performance' : 'Performance mode on';
      performanceBtn.classList.toggle('is-active', mode !== 'aesthetic');
      performanceBtn.setAttribute('aria-pressed', mode !== 'aesthetic' ? 'true' : 'false');
    }
  }

  function openPanel(){
    var trigger = $('[data-crwnz-perf-trigger]');
    var panel = $('[data-crwnz-perf-panel]');
    show(panel);
    if (trigger) trigger.setAttribute('aria-expanded','true');
  }
  function closePanel(){
    var trigger = $('[data-crwnz-perf-trigger]');
    var panel = $('[data-crwnz-perf-panel]');
    hide(panel);
    if (trigger) trigger.setAttribute('aria-expanded','false');
    try { sessionStorage.setItem(noticeKey, '1'); } catch(e) {}
  }

  function initMode(){
    var saved = 'performance';
    try { saved = localStorage.getItem(modeKey) || 'performance'; } catch(e) {}
    if (!isDesktopHelper()) saved = 'performance';
    setMode(saved === 'aesthetic' ? 'aesthetic' : 'performance', 'boot');
  }

  function bind(){
    initMode();
    var helper = $('[data-crwnz-perf]');
    if (!helper || helper.dataset.ready === '1') return;
    helper.dataset.ready = '1';
    if (isDesktopHelper()) show(helper);

    var trigger = $('[data-crwnz-perf-trigger]', helper);
    var close = $('[data-crwnz-perf-close]', helper);
    var aesthetic = $('[data-crwnz-perf-aesthetic]', helper);
    var performance = $('[data-crwnz-perf-performance]', helper);

    if (trigger) trigger.addEventListener('click', function(){
      var panel = $('[data-crwnz-perf-panel]', helper);
      if (panel && !panel.hidden) closePanel(); else openPanel();
    });
    if (close) close.addEventListener('click', closePanel);
    if (aesthetic) aesthetic.addEventListener('click', function(){ setMode('aesthetic', 'manual'); openPanel(); });
    if (performance) performance.addEventListener('click', function(){ setMode('performance', 'manual'); openPanel(); });

    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closePanel(); });

    helper.querySelectorAll('[data-browser-link]').forEach(function(link){
      link.addEventListener('click', function(){
        var txt = link.getAttribute('href');
        if (navigator.clipboard && txt) navigator.clipboard.writeText(txt).catch(function(){});
      });
    });
  }

  function monitorPerformance(){
    if (!isDesktopHelper() || isCheckoutLike) return;
    if (currentMode() !== 'aesthetic') return;
    if (!('requestAnimationFrame' in window)) return;

    var start = 0, last = 0, frames = 0, slowFrames = 0, terribleFrames = 0, worst = 0;
    var longTasks = 0;
    var observer = null;
    if ('PerformanceObserver' in window) {
      try {
        observer = new PerformanceObserver(function(list){
          list.getEntries().forEach(function(entry){ if(entry.duration > 90) longTasks++; });
        });
        observer.observe({entryTypes:['longtask']});
      } catch(e) { observer = null; }
    }

    function finish(){
      if (observer) { try { observer.disconnect(); } catch(e){} }
      var elapsed = Math.max(1, (performance.now() - start) / 1000);
      var fps = frames / elapsed;
      var severe = fps < 24 || terribleFrames >= 10 || slowFrames >= 34 || longTasks >= 5 || worst > 420;
      if (severe && currentMode() === 'aesthetic') {
        setMode('performance', 'severe');
        var helper = $('[data-crwnz-perf]');
        if (helper) helper.classList.add('is-warning');
        try { if (sessionStorage.getItem(noticeKey) !== '1') openPanel(); } catch(e) { openPanel(); }
      }
    }

    function step(ts){
      if (currentMode() !== 'aesthetic') { if(observer) { try { observer.disconnect(); } catch(e){} } return; }
      if (!start) { start = ts; last = ts; }
      var delta = ts - last;
      last = ts;
      frames++;
      if (delta > 55) slowFrames++;
      if (delta > 115) terribleFrames++;
      if (delta > worst) worst = delta;
      if (ts - start > 9000 || frames > 520) finish();
      else requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function boot(){
    bind();
    window.setTimeout(monitorPerformance, 12000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true });
  else boot();
  document.addEventListener('shopify:section:load', bind);
})();
